<section class="footer-section">
    <div class="container">
      <div class="footer-grid">
        <!-- Company Info Column -->
        <div class="footer-column company-info">
          <div class="footer-logo">
            <img src="assets/img/logo.png" alt="Kharaaj Logo" class="logo-img">
            <div class="logo-text">
              <h2 class="company-name">منصة خراج</h2>
              <p class="company-tagline">منصة تجارة الجملة للفواكه والخضار</p>
            </div>
          </div>
          <p class="company-description">
            منصة خراج أول منصة من نوعها لتجارة الفواكه والخضار بالجملة صادره عن شركة سعودية / شركة انجم لتقنية المعلومات.
          </p>
          <div class="social-links">
            <a href="https://www.youtube.com/channel/UCHKg5f08j0G2xhMjQQdpySA" target="_blank" class="social-icon youtube">
              <i class="fab fa-youtube"></i>
            </a>
            <a href="https://twitter.com/kharaajsa" target="_blank" class="social-icon twitter">
              <i class="fab fa-twitter"></i>
            </a>
            <a href="https://www.snapchat.com/add/kharaajsa" target="_blank" class="social-icon snapchat">
              <i class="fab fa-snapchat"></i>
            </a>
            <a href="https://www.instagram.com/kharaajsa/" target="_blank" class="social-icon instagram">
              <i class="fab fa-instagram"></i>
            </a>
          </div>
        </div>
  
        <!-- Quick Links Column -->
        <div class="footer-column quick-links">
          <h3 class="footer-title">روابط مفيدة</h3>
          <ul class="footer-menu">
            <li><a routerLink="join-us" class="footer-link">
              <i class="fas fa-user-plus"></i> انضم إلينا
            </a></li>
            <li><a (click)="downloadFile()" class="footer-link">
              <i class="fas fa-file-contract"></i> الشروط والأحكام
            </a></li>
            <li><a routerLink="/contact" class="footer-link">
              <i class="fas fa-envelope"></i> اتصل بنا
            </a></li>
            <li><a routerLink="/faq" class="footer-link">
              <i class="fas fa-question-circle"></i> الأسئلة الشائعة
            </a></li>
          </ul>
        </div>
      </div>
    </div>
  
    <!-- Copyright Section -->
    <div class="copyright-section">
      <div class="container">
        <div class="copyright-content">
            <p>
                <i class="far fa-copyright"></i> منصة خراج ٢٠٢٥، جميع الحقوق محفوظة لشركة انجم لتقنية المعلومات
              </p>
        </div>
      </div>
    </div>
  
    <!-- Back to Top Button -->
    <div class="back-to-top">
      <i class="fas fa-chevron-up"></i>
    </div>
  </section>